/* eslint-disable @typescript-eslint/no-explicit-any */
import { Modal, Spinner } from 'react-bootstrap';
interface Props {
  header?: string;
  mainText?: string;
  dialog?: any;
  setDialog?: any;
  handleAction?: any;
  type?: any;
  formik?: any;
  dialogCondition?: any;
  isLoading?: any;
  extraData?: any;
  returnData?: any;
  loadingDialog?: any;
}
const CustomeDialog = ({
  header,
  mainText,
  dialog,
  setDialog,
  handleAction,
  type,
  formik,
  dialogCondition,
  isLoading,
  extraData,
  returnData,
  loadingDialog
}: Props) => {
  return (
    <Modal show={dialog.type} aria-labelledby="example-modal-sizes-title-lg">
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">{header}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>{mainText}</span>
        {extraData && (
          <div>
            {' '}
            {/* {intl.formatMessage({ id: "Do.you.changes.booking" })} */}
            Charges applied
            {loadingDialog ? (
              <div className="text-center mt-8">
                {isLoading && (
                  <div className="d-flex mb-3" style={{ marginTop: '6px' }}>
                    <Spinner
                      animation="border"
                      variant="primary"
                      className="mt-2"
                    />
                    <span
                      className="ml-2"
                      style={{ paddingTop: '16px', marginLeft: '4px' }}
                    >
                      loading...
                    </span>
                  </div>
                )}
              </div>
            ) : (
              <ul>
                {' '}
                {returnData?.extra_return_price ? (
                  <li>
                    {'Extra Return Price: ' + returnData?.extra_return_price}{' '}
                  </li>
                ) : (
                  ''
                )}{' '}
                {returnData?.pod_price ? (
                  <li> {'Pod Price: ' + returnData?.pod_price} </li>
                ) : (
                  ' '
                )}
                {returnData?.extraMiles?.id ? (
                  <li>
                    {' '}
                    {'Extra Miles Price: ' +
                      returnData?.extraMiles?.totalPrice}{' '}
                  </li>
                ) : (
                  ' '
                )}
                <li>
                  Total Price:
                  {(+returnData?.extra_return_price || 0) +
                    (+returnData?.pod_price || 0) +
                    (+returnData?.extraMiles?.totalPrice || 0)}
                </li>
              </ul>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={() => setDialog({ type: false, check: '', id: '' })}
            className="btn btn-light btn-elevate"
            disabled={isLoading ? isLoading : false}
          >
            No
          </button>
          <> </>
          <button
            type="button"
            onClick={() => {
              if (type === 'order' && !dialogCondition) {
                formik.handleSubmit();
                setDialog({ type: false });
                return;
              } else if (type === 'overwrite') {
                handleAction('overwrite');
                return;
              }
              handleAction(dialog?.check, dialog?.id);
            }}
            // onDoubleClick={() => ""}
            className="btn btn-delete btn-elevate"
            disabled={
              isLoading
                ? isLoading
                : false || formik?.isSubmitting
                ? formik?.isSubmitting
                : false
            }
          >
            Yes
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomeDialog;
